import type { SerializedConstructor } from '@langchain/core/load/serializable';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = [
  'amazon.titan-tg1-large',
  'amazon.titan-text-lite-v1',
  'amazon.titan-text-express-v1',
  'ai21.j2-grande-instruct',
  'ai21.j2-jumbo-instruct',
  'ai21.j2-mid',
  'ai21.j2-mid-v1',
  'ai21.j2-ultra',
  'ai21.j2-ultra-v1',
  'anthropic.claude-instant-v1',
  'anthropic.claude-v1',
  'anthropic.claude-v2',
  'cohere.command-text-v14',
  'cohere.command-light-text-v14',
  'meta.llama2-13b-chat-v1',
  'meta.llama2-70b-chat-v1',
  'meta.llama2-13b-v1',
  'meta.llama2-70b-v1',
].map((value) => ({ label: value, value }));

export const DEFAULT_MODEL = 'amazon.titan-tg1-large';

export function useBedrockModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model || DEFAULT_MODEL;

  if (props.variant === 'line') {
    return {
      model,
      provider: id,
    };
  }
  return null;
}
